type View = "portal" | "pdf" | "chat";

interface HeroProps {
  setActiveView: (v: View) => void;
  onOpenExperiment?: () => void;
}

export default function HeroSection({ setActiveView, onOpenExperiment }: HeroProps) {
  return (
    <section
      className="relative py-20 px-4 text-white overflow-hidden"
      style={{
        background: "linear-gradient(135deg, #1e3a5f 0%, #2d6a4f 50%, #52b788 100%)",
      }}
    >
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-white blur-3xl" />
        <div className="absolute bottom-10 right-10 w-96 h-96 rounded-full bg-white blur-3xl" />
      </div>

      <div className="relative max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/20 text-sm font-medium mb-6 backdrop-blur-sm">
          🎭 Scenekunst · Innovation · Eksperiment
        </div>

        <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
          Lokalt Innovations hus i Haslev by
        </h1>

        <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto mb-10 leading-relaxed">
          Et kulturelt samlingssted i Haslev, dedikeret til scenekunst, innovation
          og eksperimenterende projekter — <strong>for børn, unge og voksne</strong>.
        </p>

        {/* CTA buttons */}
        <div className="flex flex-wrap justify-center gap-4">
          <button
            onClick={() => setActiveView("chat")}
            className="px-8 py-4 bg-white text-green-800 font-semibold rounded-xl hover:bg-green-50 transition-colors shadow-lg text-base"
          >
            💬 Spørg Assistenten
          </button>
          <button
            onClick={() => setActiveView("pdf")}
            className="px-8 py-4 bg-white/20 text-white font-semibold rounded-xl hover:bg-white/30 transition-colors backdrop-blur-sm border border-white/30 text-base"
          >
            📄 Se Dokumenter
          </button>
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          {[
            { value: "🎭", label: "Scenekunst", onClick: undefined as (() => void) | undefined },
            { value: "🧪", label: "Eksperiment", onClick: onOpenExperiment },
            { value: "👶→🧓", label: "Alle aldre", onClick: undefined as (() => void) | undefined },
            { value: "Med AI", label: "vores Digitale Co-Creator", onClick: undefined as (() => void) | undefined },
          ].map((stat) => (
            <div
              key={stat.label}
              className={"bg-white/15 backdrop-blur-sm rounded-xl p-4" + (stat.onClick ? " cursor-pointer hover:bg-white/25 transition-colors" : "")}
              onClick={stat.onClick}
            >
              <div className="text-3xl font-bold text-green-200">{stat.value}</div>
              <div className="text-sm text-white/80 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
